import React, { useContext, useEffect, useMemo, useState } from "react";
import "../ThirdTab/ThirdTab.css";
import { Link } from "react-router-dom";
import ThirdTab from "./ThirdTab";
import Breadcrumb from "react-bootstrap/Breadcrumb";

import { Context } from "../../../../utils/context.js";
import Common_Ad_Banner from "../../../common_components/common_ad_banner/Common_Ad_Banner.js";
import {
  BannersIDS,
  commonBannerApi,
} from "../../../../utils/commonBannerApi.js";
const ThirdTabMain = () => {
  const { getData, NoDataAnimations } = useContext(Context);
  const [display, setDisplay] = useState(false);
  const numberOfJobs = 5;
  const jobs = Array.from({ length: numberOfJobs }, (_, index) => ({
    role: "Data Analyst",
  }));

  const [matched, setMatched] = useState([]);
  const handleClick = async (data) => {
    console.log(data, "data");
    
    await setMatched(data);
    await setDisplay(!display);
  };

  const [matchedData, setMatchecData] = useState([]);
  const getMatched = async () => {
    const res = await getData(`/recruiters/job/all-matched`);
    if (res?.success) {
      setMatchecData(res.data);
    }
  };
  useEffect(() => {
    getMatched();
  }, []);
  useEffect(() => {
    getMatched();
  }, [display]);

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.RPMatchedPortfolios);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  return (
    <>
      <section
        className="manage-job"
        style={{ display: display ? "none" : "block" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div
                className="row  my-md-5  my-3 "
                style={{ display: display ? "none" : "" }}>
                {matchedData?.map((value, index) => (
                  <div
                    key={index}
                    className="col-xl-4 col-lg-4 col-md-4 col-md-3 mb-3">
                    <div className="text-holder-manage-job text-md-center ">
                      <div className="matched-portfolio">
                        <p className="mb-0">Company</p>
                        <h5>{value?.job?.company?.name}</h5>
                        <p className="mb-0">Role</p>
                        <h5>{value?.job?.role?.name}</h5>

                        <button
                          className="btn view-all"
                          onClick={() => handleClick(value)}>
                          View Candidate's Match
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {matchedData?.length === 0 && <NoDataAnimations />}
              </div>
            </div>

            <div className="col-lg-3 col-sm-4 col-10">
              <Common_Ad_Banner imgSrc={imgSrcNew} />
            </div>
          </div>
        </div>
      </section>

      {display && (
        <>
          <div className="row ms-0 me-0">
            <div className="col-xl-8 col-lg-10 col-md-10  col-10 mx-auto">
              <Breadcrumb className="matchedPortfolio_breadcrum_main">
                <Breadcrumb.Item
                  className="matchedPortfolio_breadcrum"
                  onClick={() => setDisplay(false)}>
                  Back
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>

          <ThirdTab
            data={matched}
            setDisplay={setDisplay}
            getMatched={getMatched}
          />
        </>
      )}
    </>
  );
};

export default ThirdTabMain;
